exports.components = {
  "component---src-pages-auth-js": () => import("./../../../src/pages/auth.js" /* webpackChunkName: "component---src-pages-auth-js" */),
  "component---src-pages-battle-demo-js": () => import("./../../../src/pages/battle-demo.js" /* webpackChunkName: "component---src-pages-battle-demo-js" */),
  "component---src-pages-deck-js": () => import("./../../../src/pages/deck.js" /* webpackChunkName: "component---src-pages-deck-js" */),
  "component---src-pages-game-js": () => import("./../../../src/pages/game.js" /* webpackChunkName: "component---src-pages-game-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

